var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 472",
    d: "M0 0h28v28H0z",
    style: {
      fill: "none"
    },
    transform: "translate(1.746)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 473",
    d: "M30.8 4H5.2a3.265 3.265 0 0 0-3.184 3.333l-.016 20a3.278 3.278 0 0 0 3.2 3.333h25.6a3.278 3.278 0 0 0 3.2-3.333v-20A3.278 3.278 0 0 0 30.8 4zm0 6.667L18 19 5.2 10.667V7.333L18 15.667l12.8-8.334z",
    transform: "translate(-2 -3)",
    style: {
      fill: "current"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignmail);
export default __webpack_public_path__ + "static/media/signmail.91f1183914936ff88660f048cb018827.svg";
export { ForwardRef as ReactComponent };